import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import { GeneratePCFList, StudentEventStatus } from './PCFUI'
import { REQUEST_TARGET_MODULES } from '../../../../../Library/APIsTarget';
import LoadingBtn from '../../../../Widgets/LoadingBtn';
import { AlertNotif } from '../../../../../Library/AlertNotif';

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function PCFApproved({ data }) {
    return (
        <div className="card card-custom gutter-b mb-8">
            <div className="card-body">
                <StudentEventStatus data={data} />

                <div className="preview-pcf">
                    <ListCoursePCF eventid={data.id} atp={data.atp_term} studentid={data.studentid} pcf_pending={data?.is_pending || 0} />
                </div>
            </div>
        </div>
    )
}

const ListCoursePCF = ({ eventid, atp, studentid, pcf_pending }) => {
    const [tcreditAct, setTcreditAct] = useState(0);
    const [courses, setCourses] = useState({
        loading: false,
        data: [],
        message: ""
    });
    const GET_COUNSELING_PCF = async () => {
        setCourses({ message: "", loading: true, data: [] });
        const param = {
            parameters: { "eventid": eventid },
            target_data: "GET_COUNSELING_PCF",
        };
        const results = await REQUEST_TARGET_MODULES(param);
        if (results.data && Object.values(results.data).length > 0) {
            const FPCF = results.data.filter(prev => (prev.action_type));
            FPCF.sort((a, b) => a.semester - b.semester);
            if (Object.values(FPCF).length > 0) {
                let resObj = GeneratePCFList(results.data);
                const totalCredit = resObj.reduce((a, v) => a = a + ((v.action_type === 'add' && v.detail.not_billed === 0) ? v.detail.credit : 0), 0);
                setTcreditAct(totalCredit);
                setCourses({ message: "", loading: false, data: resObj });
            } else {
                setCourses({ data: [], loading: false, message: "No record found" });
            }

        } else {
            setCourses({ data: [], loading: false, message: results.message || "No record found" });
        }
    }

    const [fpcf, setFpcf] = useState({ loading: false, data: [], message: "" });
    const [sumall, setSumall] = useState(0);

    const GET_STUDENT_COURSE = async () => {
        setFpcf({ loading: true, data: [], message: "" });
        const param = {
            parameters: {
                studentid: studentid,
                atpid: atp.id
            },
            target_data: "GET_STUDENT_COURSE",
        };
        const results = await REQUEST_TARGET_MODULES(param);
        if (results.data && Object.values(results.data).length > 0) {
            const total = results.data.reduce((a, v) => a = a + ((v.status === 'ACTIVE' && v.course.not_billed === 0) ? v.credit : 0), 0);
            setSumall(total);
            setFpcf({ loading: false, data: results.data, message: "" });
        } else {
            setFpcf({ data: [], loading: false, message: results.message || "No record found" });
        }
    }

    useEffect(() => {
        if (pcf_pending !== 1) {
            GET_COUNSELING_PCF();
            GET_STUDENT_COURSE();
        }
    }, [pcf_pending])

    if (pcf_pending === 1) {
        return (
            <AlertNotif title={"PCF Status"} message={`I would like to report that this student's PCF status is currently pending while we conduct a review for schedule time conflicts. Once the schedule is confirmed to be conflict-free, I will proceed to release the final course.`} color={"info"} />
        )
    } else {
        return (
            <div id="activity-student">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="card">
                            <div className="card-body">
                                <h3 className="mb-5 text-uppercase">
                                    Final PCF
                                </h3>
                                {fpcf.loading ? <LoadingBtn /> : (
                                    fpcf.message ? <AlertNotif title={"Information"} message={fpcf.message} color={"danger"} /> :
                                        Object.values(fpcf.data).length > 0 ? (
                                            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr className="text-left text-uppercase">
                                                        <th width="5%">No</th>
                                                        <th>Course Code</th>
                                                        <th>Course Title</th>
                                                        <th>Credit</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {fpcf.data.map((v, index) => {
                                                        return (
                                                            <tr key={index} className={v.status === "CANCEL" ? "bg-light-danger" : ""}>
                                                                <td>{index + 1}</td>
                                                                <td>{v.course.code}</td>
                                                                <td>{v.course.coursetitle}</td>
                                                                <td>{v.credit}</td>
                                                                <td>{v.status}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={5} className="font-weight-bolder text-center">Total Credit {sumall} SKS</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        ) : ""
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="card">
                            <div className="card-body">
                                <h3 className="mb-5 text-uppercase">
                                    History Activity PCF
                                </h3>
                                {courses.loading ? <LoadingBtn /> : (
                                    courses.message ? <AlertNotif title={"Information"} message={courses.message} color={"danger"} /> : (
                                        Object.values(courses.data).length > 0 ? (
                                            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr className="text-left text-uppercase">
                                                        <th width="5%">No</th>
                                                        <th>Course</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {courses.data.map((v, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <span className="d-block font-weight-bold">{v.detail.coursetitle} / {v.detail.course_code}</span>
                                                                <span className="d-block">Credit {v.detail.course_credit}</span>
                                                            </td>
                                                            <td>
                                                                <span className={"badge badge-" + (v.action_type === "add" ? "success" : "danger")}>{v.action_type}</span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan={2} className="text-center">
                                                            <span className="font-weight-bolder">Total Credit {tcreditAct} SKS</span>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        ) : ""))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
